export const HQ_SCAN_ROLES = Object.freeze(["admin", "manager"]);

export function canUseHqScan(role) {
  return HQ_SCAN_ROLES.includes(role);
}

export function activeTenantStores(stores) {
  return (Array.isArray(stores) ? stores : []).filter((store) => store?.active !== false);
}

export function initialHqStoreId(user, stores) {
  const activeStores = activeTenantStores(stores);
  if (user?.role === "manager") {
    return activeStores.some((store) => store.id === user.store_id)
      ? user.store_id
      : "";
  }
  return user?.role === "admin" && activeStores.length === 1
    ? activeStores[0].id
    : "";
}

export function managerStoreIsLocked(user, selectedStoreId) {
  return user?.role === "manager" && !!user.store_id && selectedStoreId === user.store_id;
}
